import styles from './ToolFrame.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToolFrame = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("aside", {
    className: styles.toolFrame,
    ...rest,
    children: children
  });
};